import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { GetStartedPage } from '@/features/get-started/get-started-page'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_auth/$orgId/get-started')({
  component: GetStartedRoute,
})

function GetStartedRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Get started')}</title>
      </Helmet>
      <GetStartedPage />
    </>
  )
}
